import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-threshold-value.ts';

const modelValueType: Record<TModelValueType, string> = {
  value: 'Statisch',
  factoredLimit: 'Dynamisch',
  limitMin: 'Achsen minimum',
  limitMax: 'Achsen maximum',
  infinity: '+∞',
};

export default {
  modelValueType,
};
